import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { SITE } from "@/data/site";

export const StickyCall = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 flex border-t border-black/10 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] md:hidden" data-testid="sticky-call">
    <a href={`tel:${SITE.phoneOffice}`} data-testid="sticky-call-btn" className="flex flex-1 items-center justify-center gap-2 bg-clay py-3.5 font-sans text-sm font-medium text-white">
      <Phone size={16} /> Call now
    </a>
    <Link to="/new-patient" data-testid="sticky-book-btn" className="flex flex-1 items-center justify-center gap-2 bg-ink py-3.5 font-sans text-sm font-medium text-linen">
      <CalendarCheck size={16} /> Book now
    </Link>
  </div>
);
